import { removeSelectedCustomPanel } from "@/utils/va-order-test/testAndPanelSelection/customPanelSelection";
import { addSelectedDiscountPanel, removeSelectedDiscountPanel } from "@/utils/va-order-test/testAndPanelSelection/discountPanelSelection";
import { removeSelectedSeasonalPromo } from "@/utils/va-order-test/testAndPanelSelection/seasonalPromoSelection";
import { removeSelectedShortcut } from "@/utils/va-order-test/testAndPanelSelection/shortcutSelection";
import { addSelectedTest, removeSelectedTest } from "@/utils/va-order-test/testAndPanelSelection/testSelection";
import { addSelectedXChooseYPanel, removeSelectedXChooseYPanel } from "@/utils/va-order-test/testAndPanelSelection/xChooseYPanelSelection";

export function handleDiscardList(discardList, orderTestSupportObj) {
  discardList.forEach(item => {
    switch(item.category) {
      case "discountPanel":
        removeSelectedDiscountPanel(item.id, "isSelect", orderTestSupportObj);
        break;
      case "xChooseY":
        removeSelectedXChooseYPanel(item.id, "isSelect", orderTestSupportObj);
        break;
      case "customPanel":
        removeSelectedCustomPanel(item.id, "isSelect", orderTestSupportObj);
        break;
      case "seasonalPromo":
        removeSelectedSeasonalPromo(item.promo, "isSelect", orderTestSupportObj);
        break;
      case "shortcut":
        removeSelectedShortcut(item.id, "isSelect", orderTestSupportObj);
        break;
      default:
        removeSelectedTest(item.id, "isSelect", orderTestSupportObj);
        break;
    }     
  });
}

export function handleDifferentAndSamePriceList(differentPriceList, samePriceList, orderTestSupportObj) {
  differentPriceList.concat(samePriceList).forEach(item => {    
    switch(item.category) {
      case "discountPanel":
        removeSelectedDiscountPanel(item.fromId, "isSelect", orderTestSupportObj);
        addSelectedDiscountPanel(item.toId, "isSelect", orderTestSupportObj);
        break;
      case "xChooseY":
        removeSelectedXChooseYPanel(item.fromId, "isSelect", orderTestSupportObj);
        addSelectedXChooseYPanel(item.toId, "isSelect", orderTestSupportObj);
        break;
      // case "seasonalPromo": //TODO
      //  removeSelectedSeasonalPromo(item, "isSelect", this.orderTestSupportObj);
      //  addSelectedSeasonalPromo(item, "isSelect", this.orderTestSupportObj);
      //  break;
      default:
        removeSelectedTest(item.fromId, "isSelect", orderTestSupportObj);
        addSelectedTest(item.toId, "isSelect", orderTestSupportObj);
    }
  });
}